module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./StoreRenewalView.js"));
	}, "StoreRenewalView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=StoreRenewalView!./src/pages/Register/StoreRenewal/StoreRenewalView.js
// module id = 829
// module chunks = 438